<template>
  <transition name="slide-fade">
    <div>
      <router-link
        class="d-flex justify-content-between"
        :to="{ name: 'scenario-view', params: { uuidId: scenario.uuid_id }}"
      >
        <div class="d-flex align-items-center">
          <img
            :src="deviceThumb"
            alt="Thumbnail of the scenarios default device"
            class="isim-favourite-scenario-image d-block d-md-none d-lg-block"
          />
          <div class="d-flex flex-column text-left">
            <h6>{{ scenario.name }}</h6>
            <div class="d-flex align-items-center">
              <img src="../assets/nav-icons/user.svg" alt="">
              <span class="d-block ml-2">{{ contributedBy }}</span>
            </div>
          </div>
        </div>

        <i
          class="remove-button material-icons"
          @click.prevent="removeScenarioFromFavourites"
          >remove_circle</i
        >
      </router-link>
    </div>
  </transition>
</template>

<script>
import Scenario from "./Scenario";
import { mapState } from "vuex";
export default {
  name: "FavouriteScenario",
  extends: Scenario,
  computed: {
    ...mapState("favouritesStore", {
      isLoading: state => state.isLoadingFavouriteScenarios
    }),
  },
  methods: {
    removeScenarioFromFavourites() {
      if (this.isLoading)
        return;

      this.$store.dispatch("favouritesStore/removeScenarioFromFavourites", this.scenario.uuid_id);
    }
  }
};
</script>

<style scoped>
.isim-favourite-scenario-image {
  width: 65px;
  height: 52px;
  border-radius: 8px;
  margin-right: 0.75rem;
}

.remove-button {
  margin: auto 0;
  cursor: pointer;
  font-size: 25px;
  color: var(--isim-danger);
}
</style>
